/*
*
* File JS per il template Archive Project
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import heroBig from 'components/hero-big/hero-big';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardGuest from 'components/card-guest/card-guest';
import blockAltTextImage from 'components/block-alt-text-image/block-alt-text-image';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-project.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();
blockAltTextImage();

//--------------------------------------------------------------------//